module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAKpJREFUWEftlTEOwjAMRX8XDsGOlOEfgZVTMHMrRk7Bzg1iKQMrHAJFMsrWJVXSVqpU/cy28/3kbw/Y+A0b/w8JEAER6CZgZld3fwC4k7wttfG+BJjZ090vAM4kXy10ViWwqoAY4690QPIw7mRqBmoCUkrHnPMHwJvkaVyvSkACRGBXBKb2QdUFxTolMYTwXWrDWQJqSboFLfu9J6b7FvQUb4mVABEQARH4AzuxEDA6kRweAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/modeling3.png
// module id = XVPR
// module chunks = 1